import type { FullAccessUser, Representative } from "../../types/application";

export const getAssignedFullAccesUsers = (
	applicant: Representative | undefined,
	fullAccessUsers: FullAccessUser[],
) => {
	if (!applicant) return [];

	const currentApplicant = {
		firstName: applicant.names.firstNames,
		lastName: applicant.names.lastNames,
		nationalId: applicant.nationalId,
		isApplicant: true,
	};

	const users = fullAccessUsers.map((f) => ({
		firstName: f.names.firstNames,
		lastName: f.names.lastNames,
		nationalId: f.nationalId,
		isApplicant: false,
	}));

	return [currentApplicant, ...users];
};

export const getUnassignedRepresentatives = (
	representatives: Representative[] = [],
	assignedFullAccesUsers: Array<{ nationalId: string }>,
	signatories: Array<{ nationalId: string }> = [],
) =>
	representatives.filter(
		(representative) =>
			!assignedFullAccesUsers.some((user) => user.nationalId === representative.nationalId) &&
			representative.role !== "Styrelsesuppleant" &&
			signatories.some((signatory) => signatory.nationalId === representative.nationalId),
	);
